<template>
  <div class="main">
    <media-header-peo></media-header-peo>
    <div class="main-header">
      <el-row :gutter="10" style="
          display: flex;
          justify-content: flex-end;
          padding-top: calc(100vw * 80 / 1920);
        ">
        <el-col :lg="10" :sm="6" style="display: flex;">
          <img class="logo-img" @click="toIndex()" src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/research_logo.png"
               style="width: calc(100vw * 200 / 1920); height: calc(100vw * 85 / 1920);"/>
        </el-col>

        <el-col :lg="14" :sm="18" class="navbar">
          <div v-for="(item, index) in titles" :key="index" :class="item.selected ? 'title_selected' : ''" class="title"
               @click="toPage(item)">
            {{ item.title }}
          </div>
          <div class="title">
            <div style="
                display: flex;
                justify-content: center;
                align-items: center;
                width: calc(100vw * 50 /1920);
                height: calc(100vw * 50 /1920);
                border-radius: 50%;
                background-color: #4063f9;
                margin-top: calc(100vw * -10 /1920);
              ">
              <img src="../assets/icon/search.png" style="width: calc(100vw * 35 /1920); height: calc(100vw * 35 /1920)"/>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>

    <div class="people-main">
      <el-row class="people-title">
        <div class="page-nav">
          <div class="orange-block"></div>
          <div class="page-title">PEOPLE</div>
          <div class="orange-block"></div>
        </div>
      </el-row>

      <div>
        <div>
          <div class="part-baojin">
            <div class="part-baojin-padding">
              <div class="part-baojin-con">
                <div class="baojin_img">
                  <img src="https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/people_baojin.png"/>
                </div>
                <div class="baojin-Principal">
                  <div>
                    <div class="bao-name bold">Prof. Jin BAO 鲍进</div>
                    <div class="bao-title bold">Principal Investigator</div>
                    <div class="bao-content">
                      Professor of Neuroscience in CAS University and SIAT University,<br />
                      PhD in Neuroscience from Goettingen University, Max-Planck Institute for Biophysical Chemistry,<br />
                      Department of Prof. Erwin Neher
                    </div>
                    <div class="bao-mail bold">jin.bao@siat.ac.cn</div>
                  </div>
                </div>
              </div>
            </div>

            <div>
              <div class="bao-biography bold">Biography</div>
              <div class="bao-biography-con">
                <div class="bao-biography-subitem" v-for="(item, index) in bios" :key="index">
                  <div class="bao-biography-date">{{
                    item.year
                    }}
                  </div>
                  <div class="bao-biography-text">
                    <span>{{item.content}}</span></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <el-row class="media-768-info" :gutter="50" style="
          margin-top: 60px;
          width: 100%;
          border-bottom: 1px solid #b4b4b4;
          padding: 20px 40px;
          display: flex; 
          flex-wrap: wrap;
        ">
        <el-col v-for="(item, index) in member" :key="index" :lg="12" :sm="24" style="margin: 20px 0"
                class="media-768-infoItem positions-box" :class="index === 3 ? 'infoItem-img' : 'media-768-infoItem'">
          <el-row class="infomation-box" style="align-items: stretch;">
            <el-col class="infomation-img" :span="8" >
              <div class="col-inner">
                <div class="img-fixed-box">
                  <img :src="item.image"/>
                </div>
              </div>
            </el-col>
            <el-col :span="16" class="item-members-right">
              <div class="member-info">
              <div class="col-inner">
                <div class="member-content">
                  <el-row style="text-align: left; padding-left: calc(100vw * 20 / 1920)">
                    <el-col :span="24" class="member-name bold">{{ item.name }}</el-col>
                    <el-col :span="24" class="member-title">{{ item.title }}</el-col>
                    <el-col :span="24" class="member-major">
                      Major: {{ item.major }}
                    </el-col>
                  </el-row>
                </div>
              </div>
              </div>
            </el-col>

            <!-- 在768尺寸下显示的图片 -->
            <el-col 
              class="media-768-infoImg" :span="8" >
              <img :src="item.image"/>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row
        class="people-footer"
        :gutter="10"
        style="margin-top: calc(100vw * 60 / 1920)"
      >
        <img
          :src="require('@/assets/image/footer_people.png')"
          style="width: 100%; display: block;"
        />
      </el-row>

    </div>
  </div>
</template>

<script>
  import mediaHeaderPeo from './media/mediaHeaderPeo'

  export default {
    name: "Index",
    components: {
      mediaHeaderPeo
    },
    data() {
      return {
        titles: [
          //'Research','People','Science And Art','Join Us','Contact Us'
          {
            title: "Research",
            key: "Research",
          },
          {
            title: "People",
            key: "People",
            selected: true,
          },
          {
            title: "Science And Art",
            key: "Science",
          },
          {
            title: "Join us",
            key: "Joinus",
          },
          {
            title: "Contact us",
            key: "Contactus",
          },
        ],
        current: 2,
        bios: [
          //
          {
            year: "2020  -  now",
            content:
              "Principal Investigator, Shenzhen Institutes of Advanced Technology, CAS.",
          },
          {
            year: "2019  -  2020",
            content:
              "Professor, School of Life Science, University of Science and Technology of China.",
          },
          {
            year: "2014  -  2019",
            content:
              "Associated Professor, School of Life Science, University of Science and Technology of China, Hefei. ",
          },
          {
            year: "2011  -  2014",
            content:
              "PostDoc Researcher, Marie Curie Fellow, The French National Centre for Scientific Research (CNRS), Paris. ",
          },
          {
            year: "2005  -  2010",
            content:
              "PhD in Neuroscience, Max Planck Institute for Biophysical Chemistry, University of Goettingen, Germany. ",
          },
          {
            year: "2002  -  2005",
            content: "Master student in Physics, Tsinghua University, Beijing.",
          },
          {
            year: "1997  -  2002",
            content:
              "Bachelor student in Biomedical Engineering, Zhejiang university, Hangzhou.",
          },
        ],
        member: [
  {
    image: require("@/assets/people/Florence_Adhiambo_Anyango.png"),
    name: "Florence Adhiambo Anyango Wanga",
    title: "Master student",
    major: "Biology",
  },
  {
    image: require("@/assets/people/Dr._Tasneem_Akhtar.png"),
    name: "Dr. Tasneem Akhtar",
    title: "PostDoc Researcher",
    major: "Biology",
  },
  {
    image: require("@/assets/people/Kunlin_LIU.png"),
    name: "Kunlin LIU 刘昆霖",
    title: "Master student",
    major: "Medicine",
  },
  {
    image: require("@/assets/people/Haoyue_GUO.png"),
    name: "Haoyue GUO 郭浩月",
    title: "PhD Student",
    major: "Biomedical Engineering",
  },
  {
    image: require("@/assets/people/Longjie_JIANG.png"),
    name: "Longjie JIANG 蒋龙杰",
    title: "PostDoc Researcher",
    major: "Biomedical Engineering",
  },
  {
    image: require("@/assets/people/Xihua_WANG.png"),
    name: "Xihua WANG 王夕华",
    title: "PhD student",
    major: "Neuroscience",
  },
  {
    image: require("@/assets/people/Qi_YU.png"),
    name: "Qi YU 俞琦",
    title: "Master student",
    major: "Biology",
  },
  {
    image: require("@/assets/people/Sirui_WANG.png"),
    name: "Sirui WANG 王思瑞",
    title: "Research Assistant",
    major: "Animal Pharmacy",
  },
  {
    image: require("@/assets/people/Jiawen_ZHAO.png"),
    name: "Jiawen ZHAO 赵佳雯",
    title: "Administrative Assistant",
    major: "Quantitative economics",
  },
  {
    image: require("@/assets/people/Bingjie_YU.png"),
    name: "Bingjie YU 于冰洁",
    title: "Master student",
    major: "Neuroscience",
  },
  {
    image: require("@/assets/people/Rui_ZHU.png"),
    name: "Rui ZHU 朱睿",
    title: "PhD student",
    major: "Biology",
  },
  {
    image: require("@/assets/people/Zheng_MA.png"),
    name: "Zheng MA 马征",
    title: "Assistant Researcher",
    major: "Electrical Engineering",
  },
  {
    image: require("@/assets/people/Binyou_Wang.png"),
    name: "Binyou WANG 王彬又",
    title: "Research Assistant",
    major: "Electrical Engineering",
  },
  {
    image: require("@/assets/people/Yajie_Zhang.png"),
    name: "YaJie ZHANG 张雅洁",
    title: "PhD student",
    major: "Mathematics",
  },
  {
    image: require("@/assets/people/Churou_QIU.png"),
    name: "Churou QIU 丘楚柔",
    title: "Master student",
    major: "Neuroscience",
  },
  {
    image: require("@/assets/people/Spike.png"),
    name: "Spikes and Bursts",
    title: "Zebrafish and lanternfish",
    major: "Natation",
  },
  {
    image: require("@/assets/people/cell.png"),
    name: "Cell",
    title: "Gecko",
    major: "Clinging",
  },
  {
    image: require("@/assets/people/Nature.png"),
    name: "Manifold and Attractor",
    title: "Pantherophis guttatus (female and male)",
    major: "Slithering",
  },
],
        
      };
    },
    methods: {
      toPage(item) {
        this.$router.push(item.key);
      },
      toIndex() {
        this.$router.push({path: "/"});
      },
    },
  };
</script>

<style scoped>

  .logo-img {
    object-fit: contain;
  }

  .main {
    overflow-x: hidden;
    overflow-y: hidden;
    text-rendering: optimizelegibility;
  }

  .navbar {
    font-family: bahnschrift;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    flex-wrap: nowrap;
    cursor: pointer;
    letter-spacing: calc(100vw * -1 /1920);
  }

  .title {
    font-family: 'mon';
    font-size: calc(100vw * 20 / 1920);
    color: #4063f9;
    padding-top: calc(100vw * 10 / 1920);
    text-rendering: optimizelegibility;
  }

  .title_selected {
    font-weight: bold;
    position: relative;
    letter-spacing: calc(100vw * -1 / 1920);
  }


  .title_selected::after {
    content: "__";
    letter-spacing: calc(100vw * -1 /1920);
    color: #ff6a4a;
    font-weight: bold;
    position: absolute;
    left: calc(100vw * 10 / 1920);
    bottom: calc(100vw * 30 / 1920);
    font-size: calc(100vw * 25 / 1920);
  }

  .page-title {
    display: flex;
    justify-content: flex-start;
    font-size: calc(100vw * 45 / 1920);
    color: #4063f9;
    padding: 0 25px;
    font-weight: 800;
  }

  .orange-block {
    width: calc(100vw * 40 / 1920);
    height: calc(100vw * 5 / 1920);
    background-color: #eb5c01;
  }

  .bao-name {
    color: #595858;
    font-size: calc(100vw * 35 / 1920);
  }

  .bao-title {
    color: #595858;
    font-size: calc(100vw * 25 / 1920);
    margin-top: calc(100vw * 10 / 1920);
  }

  .bao-content {
    color: #6e6c6d;
    font-size: calc(100vw * 20 / 1920);
    margin-top: calc(100vw * 50 / 1920);
    line-height: 35px;
  }

  .bao-mail {
    color: #6e6c6d;
    font-size: calc(100vw * 25 / 1920);
    margin-top: calc(100vw * 20 / 1920);
  }

  .bold {
    font-weight: bold;
  }

  .part-baojin {
    padding: calc(100vw * 80 / 1920);
    background: url("https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/people_topbg.png") no-repeat;
    background-size: 100% 100%;
  }

  .bao-biography {
    color: #595757;
    font-size: calc(100vw * 25 / 1920);
    margin-top: calc(100vw * 20 / 1920);
    margin-left: calc(100vw * 20 / 1920);
  }

  .bao-biography-subitem {
    display: flex;
    justify-content: flex-start;
    font-size: calc(100vw * 20 / 1920);
    padding-top: calc(100vw * 10 / 1920);
    color: #595757;
    line-height: calc(100vw * 25 / 1920);
  }

  .media-768-infoItem {
    display: flex;
    align-items: stretch;
  }
  .media-768-info > .el-col {
    float: none;
  }

  .member-info {
    margin-top: auto;

    padding:
      clamp(24px, 2vw, 48px)   /* top：小 */
      clamp(24px, 1.2vw, 56px) /* right：中 */
      clamp(40px, 2.5vw, 88px) /* bottom：核心锚点 */
      clamp(24px, 1.1vw, 56px) /* left：贴左 */
  }

  .item-members {
    display: flex;
    align-items: stretch;
  }
  
  .item-members-right {
    flex: 1;
    height: 100%;
    display: flex;
    flex-direction: column;
    background: url("https://bjlab.oss-cn-hangzhou.aliyuncs.com/image/people_rightbg.png")
                no-repeat center / cover;
    opacity: 0.8;            
    overflow: hidden;
  }

  .member-name {
    font-size: clamp(18px, 1.5vw, 25px);
    margin-bottom: 0.4em;
    line-height: 1.2;
  }

  .member-title {
    margin-bottom: 0.4em;
    font-size: clamp(16px, 1vw, 22px);
  }

  .member-major {
    margin-top: 0.4em;
    font-size: clamp(16px, 1vw, 22px);
    line-height: 1.4;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }


  .el-header,
  .el-footer {
    text-align: center;
    line-height:calc(100vw * 30 / 1920);
  }

  .el-main {
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
  }


  .part-baojin-con {
    padding-bottom: calc(100vw * 20 / 1920);
    border-bottom: calc(100vw * 1 / 1920) solid #cbd5f4;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .baojin_img {
    margin-right: calc(100vw * 100 / 1920);
    margin-left: calc(100vw * 20 / 1920);
  }

  .baojin_img img{
    width: 100%;
    height: 100%;
  }

  /* title */
  .page-nav {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: calc(100vw * 80 / 1920) 0;
  }

  .bao-biography-con {
    margin-left: calc(100vw * 20 / 1920);
  }

  .bao-biography-date {
    width: calc(100vw * 160 / 1920);
  }

  @media screen and (max-width: 1200px) {

    /*当屏幕尺寸小于1200px时，应用下面的CSS样式*/
    .main {
      width: 100%;
    }

    .bao-biography-date {
      width: 20%;
      margin-right: calc(100vw * 40 / 1920);
    }

    .bao-biography-text {
      width: 80%;
    }

    .title {
      font-size: 16px !important;
    }

  }

  @media screen and (max-width: 1500px) {

    .bao-biography-date {
      width: 20%;
    }

    .bao-biography-text {
      width: 80%;
    }
  }

  /* 所有 PC（统一卡片高度规则） */
  @media screen and (min-width: 1200px) {
    
    .item-members-right {
      min-height: 180px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }

  /* 中等屏 */
  @media screen and (min-width: 1200px) and (max-width: 1599px) {
    .main {
      max-width: 1300px;
      width: 100%;
      margin: 0 auto;
    }
  }

  /* 宽屏 */
  @media screen and (min-width: 1600px) {
    .main {
      width: 80%;
      margin-left: 10%;
    }
    .item-members-right {
      height: 100%;        /* 固定高度 */
      min-height: unset;   /* ← 关键 */
    }
  }

@media screen and (min-width: 1600px) and (max-width: 1799px) {

  /* 锁死整张卡片的真实高度 */
  .infomation-box {
    height: 180px;          /* 用你已验证对齐的高度 */
    align-items: stretch;
    overflow: hidden;      /* 双保险 */
  }

  /* 右侧只负责排版，不再参与高度计算 */
  .item-members-right {
    height: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;
  }

}

  @media screen and (min-width: 769px) {
    .media-768-infoImg {
      display: none !important;
      height: 0 !important;
      padding: 0 !important;
      margin: 0 !important;
      overflow: hidden !important;
    }
  }

  @media screen and (min-width: 769px) and (max-width: 1200px) {
    .title {
      font-size: 14px !important;
    }

    .main-header {
      padding: 0 20px;
    }

    .title_selected::after {
      bottom: 10px;
    }

    .member-name {
      font-size: 18px;
    }

    .member-title {
      font-size: 14px;
    }

    .member-major {
      font-size: 12px;
    }


    .media-768-info {
      margin: 0 auto !important;
    }
  }

  /* 屏幕尺寸超出768时，元素隐藏 */
  .media-768-infoImg {
    display: none;
  }

  .header-hidden {
    display: none;
  }

  .media-768-header {
    display: none;
  }

  .media-768-footer {
    display: none;
  }

  .infomation-img .col-inner,
  .item-members-right .col-inner {
    display: flex;
    flex: 1;
  }

  .infomation-box {
    align-items: stretch;
  }

  .infomation-img {
    display: flex;
    align-items: stretch;
  }

  .img-fixed-box {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .img-fixed-box img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
    display: block;
  }

  /*当屏幕尺寸小于768px时，应用下面的CSS样式*/
  @media screen and (max-width: 768px) {
    .member-info {
      margin-top: 0 !important;   /* 关键 */
    }
    .media-768-info {
      display: block !important;   /* ❗关键 */
      margin: 0 !important;
      padding: 12px 10px !important;
    }
    .media-768-info.el-row {
      margin-top: 0 !important;
      margin-bottom: 0 !important;
    }
     .people-main > .el-row {
      margin-bottom: 0 !important;
    }

    /* 核心：信息行必须是 flex */
    .infomation-box {
      display: flex;
      align-items: center;
      width: 100%; 
    }

    /* 需要隐藏的样式 */
    .main-header {
      display: none;
    }

    .people-title {
      display: none;
    }

    .infomation-img {
      display: none;
    }

    .people-footer {
      display: none;
    }

    .part-baojin {
      background: #fff;
      padding: 30px;
    }

    /* 需要修改的样式 */
    .people-main {
      padding: 0 !important;
    }

    .part-baojin-con {
      padding-bottom: 20px !important;
    }

    .part-baojin-con > .baojin_img {
      width: 50%;
    }

    .baojin-Principal {
      width: 50%;
    }

    .part-baojin-padding {
      margin-top: 80px;
    }

    /* baijin 导航 */
    .bao-name {
      font-size: 15px;
    }

    .bao-title {
      font-size: 12px;
    }

    .bao-content {
      font-size: 12px;
      line-height: 22px;
    }

    .bao-mail {
      font-size:12px;
    }

    /* baijin 日期 */
    .bao-biography {
      font-size: 15px;
      line-height: 44px;
      margin-top: 12px;
    }

    .bao-biography-con {
      margin-top: 15px !important;
    }

    .bao-biography-con .el-col {
      font-size: 12px !important;
    }

    .el-col-offset-2 {
      margin-left: 0 !important;
    }

    .bao-biography-subitem {
      padding-top: 0 !important;
      line-height: 25px;
    }

    .bao-biography-date {
      position: relative;
      height: auto;
      width: 30% !important;
      font-size: 12px !important;
    }

    .bao-biography-text {
      font-size: 12px !important;
    }

    .bao-biography-date::before {
      position: absolute;
      content: "";
      width: 1px;
      height: 100%;
      background-color: #4063f9;
      top: 0;
      right: 0;
    }

    .bao-biography-date::after {
      position: absolute;
      content: "";
      width: 5px;
      height: 5px;
      background-color: #4063f9;
      border-radius: 4px;
      top: 9px;
      right: -2px;
    }

    .media-768-info {
      margin: 0 !important;
      margin-top: 0 !important; 
      padding: 12px 10px !important;   /* 原来 25px */
      margin-bottom: 8px !important; 
      border-bottom: none !important;
    }

    /* 学生信息 */
    .infomation-box {
      height: auto !important;
      overflow: hidden;
      display: flex;
      align-items: center;  
    }

    .media-768-infoImg {
      width: 110px;
      height: 120px;
      overflow: hidden;

      display: flex;
      justify-content: center;
      align-items: flex-start;   /* 关键：不要 center */
    }

    .media-768-infoImg img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .media-768-infoItem {
      display: flex;
      align-items: stretch;  
      height: auto !important;
    }

    .item-members-right {
      flex: 1;
      height: auto !important;
      background: #fff;
    }

    .member-name {
      margin: 0;
      font-size: 13px;
    }

    .member-title {
      font-size: 12px;
    }

    .member-major {
      font-size: 10px;
      height: 60px !important;
    }
}



  @media screen and (min-width: 2000px) and (max-width: 3000px) {

    .search_icon {
      width: calc(100vw * 32 / 1920) !important;
      height: calc(100vw * 32 / 1920) !important;
    }

    .baojin_img {
      width: 20%;
    }

    .image-fit {
      width: auto;
      height: auto;
    }

    .title_selected::after {
      font-size: calc(100vw * 43 / 1920);
    }

  }

  @media screen and (min-width: 3000px) {

    * {
      font-size: calc(100vw * 14 / 1920) !important;
    }

    .title {
      font-size: calc(100vw * 20 / 1920) !important;
    }

    .title > div {
      width: calc(100vw * 50 / 1920) !important;
      height: calc(100vw * 50 / 1920) !important;
    }

    .title img {
      width: 70% !important;
      height: 70% !important;
    }

    .bao-name {
      font-size: calc(100vw * 22 / 1920) !important;
    }

    .bao-title {
      font-size: calc(100vw * 16 / 1920) !important;
    }

    .bao-content {
      font-size: calc(100vw * 14 / 1920) !important;
      line-height: calc(100vw * 16 / 1920) !important;
    }

    .bao-mail {
      font-size: calc(100vw * 15 / 1920) !important;
    }

    .bao-biography {
      font-size: calc(100vw * 17 / 1920) !important;
    }

    .bao-biography-subitem {
      font-size: calc(100vw * 14 / 1920) !important;
    }

    .media-768-infoItem {
      display: flex;
    }


    .item-members-right {
      padding: 0 calc(100vw * 15 / 1920);
      display: flex;
      align-items: stretch;
    }

    .baojin_img {
      width: 20%;
    }

    .media-768-infoItem {
      display: flex;
    }


    .page-title {
      font-size: calc(100vw * 50 / 1920) !important;
    }

    .member-name {
      margin-top: 0 !important;
      font-size: calc(100vw * 18 / 1920) !important;
    }

    .member-title {
      font-size: calc(100vw * 16 / 1920) !important;
    }

    .member-major {
      font-size: calc(100vw * 14 / 1920) !important;
    }


    .main {
      width: 70%;
      margin: 0 auto;
    }


    .bao-biography-text {
      margin-bottom: 0.5% !important;
    }

    .bao-biography {
      margin-bottom: 0.5% !important;
    }

    .bao-biography-subitem {
      line-height: calc(100vw * 16 / 1920) !important;
    }

    .member-major {
      height: calc(100vw * 30 / 1920) !important;
      line-height: calc(100vw * 20 / 1920) !important;
    }

    .present {
      line-height: calc(100vw * 10 / 1920) !important;
      height: calc(100vw * 20 / 1920) !important;
      margin-top: calc(100vw * 20 / 1920) !important;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/People.vue